export interface PEALabeledValue {
  label: string;
  value: string;
}
